import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Bono #1 – Sistema de Evaluación Inteligente',
    subtitle: '30 páginas con:',
    list: ['Diagnóstico inicial', 'Evaluaciones por sistema', 'Evaluación final', 'Rúbrica de proyecto', 'Autoevaluación', 'Claves de corrección'],
    image: 'https://cdn.magicpatterns.com/uploads/aSCyHz4WsMQZBfDwCeS1b3/bono1_sin_fondo.png'
  }, {
    title: 'Bono #2 – MegaPack de Juegos Didácticos',
    subtitle: '40 páginas con:',
    list: ['Bingo', 'Trivia', '¿Quién soy?', 'Sopa de letras', 'Crucigramas', 'Estaciones rotativas'],
    image: 'https://cdn.magicpatterns.com/uploads/gXd34HjrCJ5QfopDrvLCzH/bono2_sin_fondo.png'
  }, {
    title: 'Bono #3 – Planificador Estratégico de Ciencias',
    subtitle: '35 páginas con:',
    list: ['Plan anual', 'Plan mensual', 'Plan semanal', 'Seguimiento individual', 'Registro de evaluación'],
    image: 'https://cdn.magicpatterns.com/uploads/8nevuoysUqhsGMPRifE3WW/bono3_sin_fondo.png'
  }];
  return <section className="bg-gray-50 py-10 md:py-14 px-4" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <div className="text-center mb-8" data-id="element-23">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-2 font-['Oswald'] uppercase" data-id="element-24">
            🎁 Regalos especiales
          </h2>
          <p className="text-lg text-[#c0392b] font-bold uppercase tracking-wide mb-1" data-id="element-25">
            Bonos incluidos hoy
          </p>
          <p className="text-gray-600 text-sm" data-id="element-26">(Sin costo adicional)</p>
          <div className="mt-2 inline-block bg-yellow-300 text-yellow-900 font-bold px-3 py-0.5 rounded text-sm transform -rotate-2" data-id="element-27">
            ¡GRATIS solo por hoy!
          </div>
        </div>

        <div className="space-y-6" data-id="element-28">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-29">
              <div className="flex flex-col md:flex-row" data-id="element-30">
                <a href="#compra" className="bg-gray-50 flex items-center justify-center p-4 md:w-1/3 cursor-pointer" data-id="element-31">
                  <img src={bonus.image} alt={bonus.title} className="w-48 h-48 md:w-56 md:h-56 object-contain hover:scale-105 transition-transform duration-300 drop-shadow-lg" data-id="element-32" />
                </a>
                <div className="p-5 md:p-6 flex flex-col justify-center md:w-2/3" data-id="element-33">
                  <div className="inline-block bg-red-600 text-white text-[10px] font-bold px-2 py-0.5 rounded mb-2 w-fit" data-id="element-34">
                    GRATIS HOY
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 font-['Oswald']" data-id="element-35">
                    🎁 {bonus.title}
                  </h3>
                  <p className="text-sm font-semibold text-gray-700 mb-2" data-id="element-36">
                    {bonus.subtitle}
                  </p>
                  <ul className="space-y-1" data-id="element-37">
                    {bonus.list.map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-600 text-sm" data-id="element-38">
                        <div className="w-1.5 h-1.5 bg-green-500 rounded-full flex-shrink-0" data-id="element-39"></div>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}